import { Segment } from '@mairistem/composants';

import PayeurListeContainer from './PayeurListe/PayeurListeContainer';

const FeaturePayeurListe = () => (
  <Segment basic secondary style={{ margin: 0, height: '100%' }}>
    <Segment id="factures-recus" style={{ height: '100%', overflow: 'hidden' }}>
      <Segment basic style={{ margin: 0, paddingTop: 0, height: '100%' }}>
        <PayeurListeContainer redirectOnEmpty />
      </Segment>
    </Segment>
  </Segment>
);

export default FeaturePayeurListe;
